export default function handleRoyalties(royalties) {
    return royalties ? parseFloat(royalties) > 10 ? "10" : parseFloat(royalties).toFixed(1) : null;
  }